module.exports = __webpack_public_path__ + "posture/static/img/leg_xo.ab3f786.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/normal/leg_xo.png
// module id = 7+Pl
// module chunks = 1